/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 *
 * I&C Monitors and Advisors (ICMA)
 */

import React from 'react';
import axios from 'axios';
import AccordionComponent from './AccordionComponent';
// import optimizationbar from '@dig-mosaic-infra/dls-microapp-optimizationbar';
import optimizationbar from 'dls-microapp-optimizationbar';
import LoadingComponent from './LoadingComponent';
import AlertComponent from './AlertComponent';
const webBFSJson = require('../../../mock/data/webBFS.json');
const enableServices = require('../../../config/lp_services.json');
export default class LandingPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      alerts: [],
      plant: null,
      loading: true,
      services: [],
      customerPortalUrl: null,
      optimizationArray: null,
      cachedApiData: {},
      cachePlantMaintApi: {},
      assignedServices: [],
      unitList: [],
      enabledServicesArray: [],
      unitIswebBFS: false,
      ppidIswebBFS: false,
      isPlantMaint: {},
      maintence_services: ['sa', 'hl', 'sha'],
      isSiemens: false,
      env: 'cp',
      username: null,
      getDetailsApiLoading: true,
      ppidToUnitsMapping: {},
      ppidToPnameMapping: {},
      contracts: []
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps }, () => {
      this.setState({
        cachePlantMaintApi: {},
        isPlantMaint: {
          sh: this.props.shaUnderMaintenance,
          sa: this.props.saUnderMaintenance,
          hl: this.props.hlUnderMaintenance
        }
      });
    });
  }
  /**
   * Remove alert from array based on the passed index from the AlertComponent
   * @param alertIndex
   */
  doRemoveAlert(alertIndex) {
    let newAlerts = this.state.alerts;
    newAlerts.splice(alertIndex, 1);
    this.setState({
      alerts: newAlerts
    });
  }

  /**
   * parse token info
   * @param token
   * @return {tokenInfoObj}
   */
  getTokenInfo(token) {
    let tokenInfo = {};
    if (token) {
      let base64Url = token.split('.')[1];
      if (base64Url) {
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let parsedSecurityToken = Buffer.from(base64, 'utf8').toString(
          'base64'
        );
        if (parsedSecurityToken && parsedSecurityToken.sub) {
          tokenInfo.email = parsedSecurityToken.sub;
          tokenInfo.is_rec = parsedSecurityToken.is_rec;
          tokenInfo.is_siemens = parsedSecurityToken.is_siemens;
          // to test locally for non siemens user
          // tokenInfo.is_siemens = false
        }
      }
    }
    return tokenInfo;
  }

  /**
   * Main render function
   * @returns {*[]}
   */
  render() {
    let accordions = this.accordionArrayGenerator();
    let alerts = this.state.alerts.map((alert, index) => (
      <AlertComponent
        index={index}
        key={index}
        type={alert.type}
        message={alert.message}
        doRemoveAlert={(alertIndex) => this.doRemoveAlert(alertIndex)}
      />
    ));
    return [
      <div key="landing_main">
        {alerts}
        {this.state.loading || this.state.getDetailsApiLoading ? (
          <LoadingComponent />
        ) : (
          accordions
        )}
        {/* <div key="lp_fleetbar" id="fleetbar" className="fleetbar"></div> */}

        {/* <FooterButton tokenDetails={this.getTokenInfo(this.props.settings.token)}/> */}
      </div>
    ];
  }

  /**
   * To get plant maintence data for each service
   * @param service
   * @param ppid
   */
  getplantunderMaintenance(service, ppid) {
    this.setState({
      cachePlantMaintApi: {},
      isPlantMaint: {
        sh: this.props.shaUnderMaintenance,
        sa: this.props.saUnderMaintenance,
        hl: this.props.hlUnderMaintenance
      }
    });
    // service.forEach((ele) => {
    //   let apicase = '';
    //   let resource = ele;
    //   }
    // TODO: check with manish where if one unit is in maintenance then are we showing all of them in maitenace on landing
    // switch (ele) {
    //   case 'sha':
    //     apicase = 'recomreqprocess';
    //     resource = 'sh';
    //     break;
    //   case 'sa':
    //     apicase = 'secreqprocess';
    //     break;
    //   case 'hl':
    //     apicase = 'obsreqprocess';
    //     break;
    //   default:
    //     break;
    // }
    // let { server, token, language } = this.props.settings;
    // let url = `${server}${ele}/${resource}.${apicase}/${resource}.isPlantUnderMaintenance/${ppid}`;
    // let body = { language: language, plantName: 'Siemens Test IDA T0003' };
    // let apiheader = {
    //   'Content-Type': 'application/json',
    //   Authorization: `Bearer ${token}`
    // };
    // axios
    //   .post(url, body, { headers: apiheader })
    //   .then((response) => {
    //     finalresult[ele] = response.data;
    //     let tempobj = Object.assign({}, this.state.cachePlantMaintApi);
    //     tempobj[ppid] = finalresult;

    //     this.setState(
    //       {
    //         cachePlantMaintApi: Object.assign({}, tempobj),
    //         isPlantMaint: tempobj[this.props.ppid]
    //       },
    //       () => {
    //         console.log('cachePlantMaintApi', this.state.cachePlantMaintApi);
    //         console.log('isPlantMaint', this.state.isPlantMaint);
    //       }
    //     );
    //   })
    //   .catch(function (error) {
    //     this.setState({
    //       cachePlantMaintApi: {},
    //       isPlantMaint: {}
    //     });
    //     console.log(`error from under maintence request call ${error}`);
    //   });
    // });
  }
  calculateContract(contract) {
    let enabledServicesSet = new Set();
    contract.forEach((ele) => {
      let trimmedServiceName = ele.substring(0, ele.indexOf('.'));
      if (trimmedServiceName === 'tpi') {
        enabledServicesSet.add('sa'); //sec
        enabledServicesSet.add('sha'); //condition
      }
      if (trimmedServiceName === 'ci') {
        enabledServicesSet.add('sa'); //sec
      }
      if (trimmedServiceName === 'sh') {
        enabledServicesSet.add('sha');
      } else {
        enabledServicesSet.add(trimmedServiceName);
      }
    });
    let enabledServices = [];
    enabledServicesSet.forEach((val) => {
      enabledServices.push(val);
    });
    return enabledServices;
  }

  /**
   * To get details content management and update the state
   */
  contentManagementApiCep() {
    this.showLoader(true);
    let contract = this.state.contracts;
    let enabledServicesArray = this.calculateContract(contract);
    this.setState({ enabledServicesArray });
  }

  /**
   * Lifecycle method called after HTML completely loaded
   */
  componentDidMount() {
    this.props.setCurrentRouteState('', 'Available Services');
    let isSiemensflag;

    // create dummy link for parsing the hostname of the current server
    const url = document.createElement('a');
    url.href = this.props.settings.server;
    // get services depending on the stage (hostname of server)
    const services = enableServices[url.hostname];

    //check for if using customer portal or cep/joint portal
    //to-do add native app QA and PROD hostnames
    // if (
    //   (window.location.hostname.includes('localhost') &&
    //     window.location.port === '3000') ||
    //   window.location.hostname.includes('native-app')
    // ) {
    this.setState(
      {
        env: 'cep',
        services
      },
      () => {
        const email = this.props.getEmailFromToken(this.props.settings.token);
        const url = `${this.props.settings.server}pi/pi.landing/pi.mapping/${this.props.ppid}?ppid=${this.props.ppid}&email=${email}`;
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${this.props.settings.token}`
            }
          })
          .then((response) => {
            let ppidToPnameMapping =
              response.data.globalSettings['ppidToPnameMapping'];
            let contracts = response.data.globalSettings['contracts'];
            isSiemensflag = response.data.globalSettings['is_siemens'];
            let ppidToUnitsMapping =
              response.data.globalSettings['ppidToUnitsMapping'];
            // let ppidToPnameMapping =
            //   this.props.lpMapping.globalSettings['ppidToPnameMapping'];
            // let contracts = this.props.lpMapping.globalSettings['contracts'];
            // isSiemensflag = this.props.lpMapping.globalSettings['is_siemens'];
            // let ppidToUnitsMapping =
            //   this.props.lpMapping.globalSettings['ppidToUnitsMapping'];
            this.setState(
              {
                getDetailsApiLoading: false,
                ppidToPnameMapping,
                contracts,
                ppidToUnitsMapping,
                isSiemens: isSiemensflag,
                ppidIswebBFS: this.props.ppid.includes('webBFS')
              },
              () => {
                // gettin content managment details from cep
                this.contentManagementApiCep();
                let maxOptimization = {};
                let allServiceMapTest = {};
                // clear alerts
                this.clearAlerts();
                if (this.state.env === 'cp') {
                  // NOTE: step 1: call customer portal api and get selected plant and update ppid if fleet
                  this.processCPFleetApiData(
                    maxOptimization,
                    allServiceMapTest
                  );
                } else if (this.state.env === 'cep') {
                  this.processCEPFleetData(maxOptimization, allServiceMapTest);
                }
              }
            );
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              getDetailsApiLoading: false
            });
          });
      }
    );
  }

  /**
   * Returns promise for requesting the service specific landing api endpiont
   * @param service
   * @param path
   * @returns {AxiosPromise}
   */
  getServiceValues(service, path) {
    let { token, server, language, startDate, endDate } = this.state.settings;

    let url = `${server}${service}/${path}/${this.props.ppid}/${language}/${startDate}/${endDate}`;

    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${token}` }
    });
  }
  /**
   * Api call for service
   * @param service
   * @param path
   * @param ppid
   * @return {AxiosPromise}
   */
  othergetServiceValues(service, path, ppid) {
    let { token, server, language, startDate, endDate } = this.state.settings;

    let url = `${server}${service}/${path}/${ppid}/${language}/${startDate}/${endDate}`;

    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  /**
   * Do api call for all the services and map data in maxOptimization and allServiceMapTest
   * @param ppid
   * @param maxOptimization
   * @param allServiceMapTest
   */
  getFleetServiceValue(ppid, maxOptimization, allServiceMapTest) {
    let serviceObj = {};
    let servicelist = [...this.state.services];
    if (ppid.includes('webBFS')) {
      servicelist = webBFSJson;
    }
    servicelist.map((service) => {
      if (service.service !== 'tr' && service.service !== 'if' && service.service !== 'mdr') {
        let newService = Object.assign({}, service);

        this.othergetServiceValues(service.service, service.path, ppid)
          .then(({ data }) => {
            // // if some services will send the data as stringified object
            newService = this.validateData(data, service, newService);
            if (Object.keys(maxOptimization).length === 0) {
              maxOptimization[data.ppid] = data.optimization;
            } else if (maxOptimization[data.ppid] < data.optimization) {
              maxOptimization[data.ppid] = data.optimization;
            } else if (maxOptimization[data.ppid] > data.optimization) {
              //no need to update the dictionary
            } else {
              maxOptimization[data.ppid] = data.optimization;
            }
            serviceObj[newService.service] = {
              optimization: newService.optimization
            };
            serviceObj[newService.service]['text'] = newService.text;
          })
          .catch((error) => {
            newService.optimization = -2;
            newService.text = ['No data received.'];

            serviceObj[newService.service] = {
              optimization: newService.optimization
            };
            serviceObj[newService.service]['text'] = newService.text;
          })
          .finally(() => {
            allServiceMapTest[ppid] = serviceObj;
            let updatedServices = this.state.services.map((oldService) => {
              if (
                oldService.service !== 'if' &&
                oldService.service !== 'tr' &&
                oldService.service !== 'mdr' &&
                !this.props.ppid.includes('webBFS')
              ) {
                if (
                  allServiceMapTest[this.props.ppid] !== undefined &&
                  allServiceMapTest[this.props.ppid][oldService.service] !==
                    undefined
                ) {
                  oldService.optimization =
                    allServiceMapTest[this.props.ppid][
                      oldService.service
                    ].optimization;
                  oldService.text =
                    allServiceMapTest[this.props.ppid][oldService.service].text;
                  return oldService;
                } else {
                  oldService.optimization = -2;

                  return oldService;
                }
              } else {
                if (
                  oldService.service === 'hl' &&
                  this.props.ppid.includes('webBFS') &&
                  allServiceMapTest[this.props.ppid] !== undefined
                ) {
                  oldService.optimization =
                    allServiceMapTest[this.props.ppid][
                      oldService.service
                    ].optimization;
                  oldService.text =
                    allServiceMapTest[this.props.ppid][oldService.service].text;
                  return oldService;
                }
                return oldService;
              }
            });
            //  sort removed
            // .sort((a, b) => b.optimization - a.optimization);
            this.setState(
              {
                services: updatedServices,
                optimizationArray: maxOptimization,
                cachedApiData: allServiceMapTest
              },
              this.createFleetOBEndLoader(true, false)
            );
          });
      }
    });
  }
  /**
   * Creates the bar at the top of the page depending on the current selected ppid and plant type
   * @param results
   */
  createFleetOptimizationBar(results, enableLoad) {
    // get highest two digit percentage optimization potential and update state
    const optimizationArr = results.map((obj) => {
      if (!this.state.isSiemens) {
        // normal
        if (
          this.state.isPlantMaint !== undefined &&
          this.state.isPlantMaint[obj.service]
        ) {
          if (
            this.state.isPlantMaint[obj.service].isUnderMnt ||
            !this.state.enabledServicesArray.includes(obj.service)
          ) {
            return -1;
          } else {
            return obj.optimization;
          }
        } else {
          return obj.optimization;
        }
      } else {
        return obj.optimization;
      }
    });
    // const optimization =
    //   Math.round(Math.max(...optimizationArr) * 100 * 100) / 100;

    // check if there are any results
    if (results.length === 0) {
      this.createAlert('warning', 'No data received for visualization.');
    }
  }

  /**
   * Return promise for customer portal api call
   * @returns {AxiosPromise}
   */
  getCustomerPortalEnvironment() {
    return axios({
      method: 'get',
      url: this.state.customerPortalUrl
    });
  }

  /**
   * Create a optimization bar for just one powerplant
   * @param optimization
   */
  createOptimizationBar(optimization, enableLoad) {
    let ob = new optimizationbar();
    let dlsPageWidth =
      document.getElementById('dls-landingpage-root').offsetWidth || 1200;
    ob.setDimension(100, dlsPageWidth);
    ob.setSliderPosition(100 - optimization);
    ob.setChartMultipliers(0.1, 0.5);
    // display optimization percentage only if valid data was responsed by at least one service (initial its set to -1), so this prevents from showing a negative value
    let optimizationText =
      optimization >= 0
        ? `${optimization}% Overall Optimization Capability`
        : 'No data received';
    ob.setSliderText(optimizationText);
    ob.setLeftLabel('HIGH');
    ob.setRightLabel('LOW');
    ob.draw('#fleetbar');
    //fix for multiple load bug
    if (enableLoad) {
      this.showLoader(false);
    }
  }

  /**
   * plantdata calculation for CEP
   * @param optimization
   * @param optimizationText
   * @return {PlantData Obj}
   */
  plantDataCalculatorCEP(optimization, optimizationText) {
    let plantData;
    let ppidToUnitsMapping = this.state.ppidToUnitsMapping;
    let ppidToPnameMapping = this.state.ppidToPnameMapping;
    let selectedPpid = this.props.ppid;
    let baseppid = this.props.ppid;
    let ppidWithUCase = false;
    let basePpidForppidWithUCase = '';
    if (selectedPpid.includes('u')) {
      baseppid = baseppid.substring(0, baseppid.indexOf('u'));
    }
    if (selectedPpid.includes('webBFS')) {
      baseppid = baseppid.substring(0, baseppid.indexOf('webBFS'));
    }
    //check for ppid(s) containing u themselves
    let subunitsarray = Object.entries(ppidToUnitsMapping);
    subunitsarray.forEach(([baseid, subunits]) => {
      if (Array.from(subunits).includes(selectedPpid)) {
        ppidWithUCase = true;
        basePpidForppidWithUCase = baseid;
      }
    });
    //check if ppid has units
    if (Object.keys(ppidToUnitsMapping).includes(baseppid)) {
      plantData = Array.from(ppidToUnitsMapping[baseppid]).map((unitid) => {
        let newnodeid = unitid;
        newnodeid = newnodeid.replace('u', '');
        return this.createPlantData(
          newnodeid,
          unitid,
          ppidToPnameMapping[unitid],
          optimization,
          optimizationText
        );
      });
      plantData.sort(this.ObjTxtSort);
    } else if (ppidWithUCase) {
      plantData = Array.from(ppidToUnitsMapping[basePpidForppidWithUCase]).map(
        (unitid) => {
          let newnodeid = unitid;
          newnodeid = newnodeid.replace('u', '');
          return this.createPlantData(
            newnodeid,
            unitid,
            ppidToPnameMapping[unitid],
            optimization,
            optimizationText
          );
        }
      );
      plantData.sort(this.ObjTxtSort);
    } else {
      let newnodeid = baseppid;
      return [
        this.createPlantData(
          newnodeid,
          baseppid,
          ppidToPnameMapping[baseppid],
          optimization,
          optimizationText
        )
      ];
    }
    return plantData;
  }

  /**
   * plantdata calculation for old CP portal
   * @param optimization
   * @param optimizationText
   * @return {PlantData Obj}
   */

  plantDataCalculatorCP(optimization, optimizationText) {
    let plantData = [];
    if (this.state.plant.units === undefined) {
      plantData = [
        this.createPlantData(
          this.props.ppid,
          this.props.ppid,
          this.state.plant.name,
          optimization,
          optimizationText
        )
      ];
    } else {
      plantData = Object.keys(this.state.plant.units).map((unit) => {
        let currentUnit = this.state.plant.units[unit];
        return this.createPlantData(
          unit,
          currentUnit.ppid,
          currentUnit.name,
          optimization,
          optimizationText
        );
      });
      plantData.sort(this.ObjTxtSort);
    }
    return plantData;
  }

  /**
   * Sort Object using text1
   * @param a
   * @param b
   * @return 0,1,-1
   */
  ObjTxtSort(a, b) {
    if (a.text1 < b.text1) return -1;
    if (a.text1 > b.text1) return 1;
    return 0;
  }

  /**
   * create plant data object
   * @param unit
   * @param ppid
   * @param text1
   * @param optimization
   * @param optimizationText
   * @return {Object}
   */
  createPlantData(unit, ppid, text1, optimization, optimizationText) {
    let tooltipText2;
    if (ppid === this.props.ppid) {
      tooltipText2 = optimizationText;
    } else {
      tooltipText2 = '';
    }
    return {
      nodeId: unit,
      ppid: ppid,
      isMarked: ppid === this.props.ppid,
      value: 0,
      // ppid === this.props.ppid
      //   ? optimization
      //   : this.state.optimizationArray !== null
      //   ? this.state.optimizationArray[this.state.plant.units[unit].ppid] *
      //     100
      //   : 0,
      text1: text1,
      tooltipText1: text1,
      tooltipText2
    };
  }

  /**
   * Creates an alert at the top of the page for different types (error, warning, success) and sets the background based on the type (see css classes)
   * @param type
   * @param message
   */
  createAlert(type, message) {
    // check type of message and set fallback to error
    type =
      type === 'error' || type === 'warning' || type === 'success'
        ? type
        : 'error';
    this.setState({
      alerts: [...this.state.alerts, { type: type, message: message }],
      loading: false
    });
  }

  /**
   * Removes all errors from page
   */
  clearAlerts() {
    this.setState({
      alerts: []
    });
  }

  /**
   * Method for showing and hiding loader
   * @param isVisible
   */
  showLoader(isVisible) {
    this.setState({
      loading: isVisible
    });
  }

  /**
   * Validate returned response of services
   * @param object
   * @param serviceKey
   * @returns {boolean}
   */
  isValid(object, serviceKey) {
    let schema = {
      ppid: (value) => {
        return typeof value === 'string' && /^[A-Za-z0-9\-]{2,20}$/.test(value);
      },
      optimization: (value) => {
        // if the service wants to just show a description without an optimization value, it sends a -2 as optimization value
        return (
          !isNaN(value) &&
          (/^(0(\.\d+)?|1(\.0+)?)$/.test(value) || value === -2 || value === -3)
        );
      },
      text: (value) => {
        return (
          value instanceof Array &&
          value.length > 0 &&
          value.every((element) => typeof element === 'string')
        );
      }
    };

    // check if response includes all required parameters
    if (
      !Object.keys(schema).every((param) => {
        if (!object.hasOwnProperty(param)) {
          console.error(
            `[ValidationError] service "${serviceKey}" does not contain required parameter "${param}".`
          );
        }
        return object.hasOwnProperty(param);
      })
    ) {
      return false;
    }

    // validate value of all parameters
    let errors = Object.keys(schema)
      .map((property) => {
        let validator = schema[property];
        return [property, validator(object[property])];
      })
      .reduce((error, pair) => {
        // if parameter is not valid
        if (pair[1] === false) {
          error.push(`[ValidationError] property "${
            pair[0]
          }" of service "${serviceKey}" has an invalid value:
        "${object[pair[0]]}" does not satisfy schema 
        ${schema[pair[0]]}
        for further information about the required scheme please see https://wiki.ct.siemens.de/x/qkIXCQ`);
        }
        return error;
      }, []);

    // log errors if any
    if (errors.length > 0) {
      errors.forEach((error) => {
        console.error(error);
      });
      return false;
    } else {
      return true;
    }
  }

  /**
   * Generating accordian
   * @param result
   * @param optimization
   * @param limited
   * @returns Accordian component
   */
  accordianGenerator(result, optimization, limited) {
    return (
      <AccordionComponent
        key={result.service + '_' + result.cpid}
        service={result.service}
        optimization={optimization}
        header={result.header}
        text={result.text}
        cpid={result.cpid}
        nativeurl={result.nativeurl}
        redirect={result.redirect}
        ppid={this.props.ppid}
        limited={limited}
        isPlantMaint={this.state.isPlantMaint}
        isSiemens={this.state.isSiemens}
        env={this.state.env}
        serviceIncluded={result.serviceIncluded}
        history={this.props.history}
      />
    );
  }

  /**
   * Calculating all the accordians which are required
   * @returns services
   */
  accordionArrayGenerator() {
    let enabledServicesArray = [...this.state.enabledServicesArray];
    return this.state.services.map((result) => {
      // case to handle unitIswebBFS case
      //  enable only for I&C lifecycle
      if (this.state.ppidIswebBFS) {
        if (result.service === 'hl') {
          return this.accordianGenerator(result, result.optimization, false);
        }
      } else {
        // case to handle T3000 report service
        //  enable only for some ppids
        if (result.service === 'tr' && enabledServicesArray.includes('tr')) {
          return this.accordianGenerator(result, result.optimization, false);
        }
        // case to handle Internal Function
        //  enable only for is_siemens employee
        else {
          if (result.service === 'if') {
            if (this.state.isSiemens) {
              return this.accordianGenerator(
                result,
                result.optimization,
                false
              );
            } else {
              return;
            }
          } else if (result.service === 'mdr') {
            if (
              !enabledServicesArray.includes('mdr') &&
              !this.state.isSiemens
            ) {
              return;
            } else if (
              this.state.isSiemens &&
              enabledServicesArray.includes('mdr')
            ) {
              return this.accordianGenerator(result, -3, false);
            } else {
              // if MDR is not subscribed for SE personal
              if (
                this.state.isSiemens &&
                !enabledServicesArray.includes('mdr')
              ) {
                return this.accordianGenerator(result, -3, 'isSiemens');
              }
            }
            return this.accodianHandleForExt(enabledServicesArray, result);
          } else {
            // case to handle Subscribed services
            // (external customer )if service is subscribe then allow
            // TO show only siemens user all services
            return this.accodianHandleForExt(enabledServicesArray, result);
          }
        }
      }
    });
  }

  /**
   * Calculating subscribed services for external user
   * @returns services
   */
  accodianHandleForExt(enabledServicesArray, result) {
    if (this.state.isSiemens) {
      if (enabledServicesArray.includes(result.service)) {
        result.serviceIncluded = true;
      } else {
        result.serviceIncluded = false;
      }
      return this.accordianGenerator(result, result.optimization, 'isSiemens');
    }

    // (external customer) else service is not subscribe
    //  then do not allow

    if (enabledServicesArray.includes(result.service)) {
      return this.accordianGenerator(result, result.optimization, false);
    }
    return this.accordianGenerator(result, -3, 'limited');
  }

  /**
   * Calculating fleet api data
   * @params maxOptimization
   * @params allServiceMapTest
   * @returns services
   */
  processCPFleetApiData(maxOptimization, allServiceMapTest) {
    this.getCustomerPortalEnvironment()
      .then(({ data }) => {
        // get current selected plant based on the current selected facilityId
        let selectedPlant =
          data.plants[this.state.settings.facilityId.toString()];
        let unitIswebBFS = false;
        let unitList = [];
        if (selectedPlant.units) {
          Object.values(selectedPlant.units).forEach((unit) => {
            if (unit.ppid.includes('webBFS')) {
              unitIswebBFS = true;
            }
          });
        }
        // if units are present select the first unit ppid as the selected one
        if (selectedPlant && selectedPlant.units) {
          unitList = Object.values(selectedPlant.units);
          // if current selected unit ppid is not present, use first unit id of current selected ppid
          let unitPpidIsPresent = Object.values(selectedPlant.units).find(
            (unit) => {
              return unit.ppid === this.props.ppid;
            }
          );
          let unitPpid =
            unitPpidIsPresent && unitPpidIsPresent.ppid
              ? unitPpidIsPresent.ppid
              : selectedPlant.units[Object.keys(selectedPlant.units)[0]].ppid;
          // NOTE: step 2a: update ppid if needed
          this.setState({
            settings: Object.assign({}, this.state.settings, {
              ppid: unitPpid
            }),
            unitList,
            unitIswebBFS
          });
        }

        // NOTE: step 2b: update selected plant
        this.setState({
          plant: selectedPlant
        });
        // No plant found in the customer portal response
        if (!selectedPlant) {
          console.error(
            `Optimization or fleet bar cannot be created, because plant  not found in customer portal response.`
          );
          this.createAlert(
            'error',
            `You are not authorized to perform this action.`
          );
        }
      })
      .catch((error) => {
        console.error(error, error.stack);
        this.createAlert(
          'error',
          `You are not authorized to perform this action.`
        );
      })
      .finally(() => {
        // check if selected ppid was found in the customer portal response
        if (!this.state.plant) {
          // update services
          this.setState({
            services: this.initialService()
          });
        } else {
          /* check if ppid contain units */
          if (this.state.plant.units || this.state.plant.length === 0) {
            //call the service api for other units
            Object.values(this.state.plant.units).map((unit) => {
              this.getFleetServiceValue(
                unit.ppid,
                maxOptimization,
                allServiceMapTest
              );
              if (!unit.ppid.includes('webBFS')) {
                this.getplantunderMaintenance(
                  this.state.maintence_services,
                  unit.ppid
                );
              }
              return null;
            });
          } else {
            this.getplantunderMaintenance(
              this.state.maintence_services,
              this.props.ppid
            );
            this.state.services.map((service) => {
              this.serviceDataCleaner(service);
            });
          }
        }
      });
  }

  /**
   * Calculating fleet api data
   * @returns services
   */
  initialService() {
    return this.state.services.map((service) => {
      service.optimization = -2;
      service.text = ['No data received.'];
      return service;
    });
  }

  /**
   * Validating response data
   * @params data
   * @params service
   * @params calculatedService
   * @returns services
   */
  validateData(data, service, calculatedService) {
    // if some services will send the data as stringified object
    let jsonData;
    if (typeof data === 'string') {
      jsonData = JSON.parse(data);
    } else {
      jsonData = data;
    }
    // validate responsed data structure
    if (this.isValid(jsonData, service.service)) {
      // update parameters
      calculatedService.optimization = jsonData.optimization;
      calculatedService.text = jsonData.text;
    } else {
      calculatedService.optimization = -2;
      calculatedService.text = ['No data received.'];
    }
    return calculatedService;
  }

  /**
   * Cleaning services data and updating the state
   */
  serviceDataCleaner(service) {
    let newService = Object.assign({}, service);
    if (service.service !== 'tr' && service.service !== 'if' && service.service !== 'mdr') {
      // let promise = this.getServiceValues(service.service, service.path);
      // promiseArray.push(promise);
      // promise.then(({data}) => {
      this.getServiceValues(service.service, service.path)
        .then(({ data }) => {
          // // if some services will send the data as stringified object
          newService = this.validateData(data, service, newService);
          // reset the optimization to -2 if plant is under maintence or services is not subscribed
          if (!this.state.isSiemens) {
            // end user
            if (
              this.state.isPlantMaint[service.service] &&
              !this.state.enabledServicesArray.includes(service.service) &&
              this.state.isPlantMaint[service.service].isUnderMnt
            ) {
              newService.optimization = -2;
            }
          }
        })
        .catch((error) => {
          newService.optimization = -2;
          newService.text = ['No data received.'];
        })
        .finally(() => {
          // update state for this object and sort by optimization value
          this.setState(
            {
              services: this.servicesGenerator(newService)
            },
            this.createFleetOBEndLoader(false, false)
          );
        });
    }
  }

  /**
   * generating services from old services from state
   * @params newService
   * @returns services
   */
  servicesGenerator(newService) {
    return this.state.services.map((oldService) => {
      return oldService.service === newService.service
        ? newService
        : oldService;
    });
  }

  /**
   * Create fleetbar and stop the loader
   * @params ObEnable
   * @params LoaderEnable
   */

  createFleetOBEndLoader(ObEnable, LoaderEnable) {
    this.createFleetOptimizationBar(this.state.services, ObEnable);
    this.showLoader(LoaderEnable);
  }

  /**
   * process CEP fleetbar data
   * @params maxOptimization
   * @params allServiceMapTest
   */
  processCEPFleetData(maxOptimization, allServiceMapTest) {
    let ppidToUnitsMapping = this.state.ppidToUnitsMapping;
    let ppidToPnameMapping = this.state.ppidToPnameMapping;

    let selectedPpid = this.props.ppid;
    let unitIswebBFS = false;
    let ppidIswebBFS = false;
    let baseppid = this.props.ppid;
    if (selectedPpid.includes('u')) {
      baseppid = baseppid.substring(0, baseppid.indexOf('u'));
    }
    //check if ppid has units
    if (Object.keys(ppidToUnitsMapping).includes(baseppid)) {
      Array.from(ppidToUnitsMapping[baseppid]).map((unitid) => {
        if (unitid.includes('webBFS')) {
          unitIswebBFS = true;
        }
        return null;
      });
    }
    ppidIswebBFS = this.props.ppid.includes('webBFS');

    if (!Object.keys(ppidToPnameMapping).includes(selectedPpid)) {
      this.createAlert(
        'error',
        `You are not authorized to perform this action.`
      );
      // update services
      this.setState({
        unitIswebBFS,
        ppidIswebBFS,
        services: this.initialService()
      });
    } else {
      //check if ppid has units
      if (Object.keys(ppidToUnitsMapping).includes(baseppid)) {
        //map iteration on unit array of ppid
        Array.from(ppidToUnitsMapping[baseppid]).map((unitid) => {
          this.getFleetServiceValue(unitid, maxOptimization, allServiceMapTest);
          if (!unitid.includes('webBFS')) {
            this.getplantunderMaintenance(
              this.state.maintence_services,
              unitid
            );
          }
          return null;
        });
      } else {
        this.getplantunderMaintenance(
          this.state.maintence_services,
          this.props.ppid
        );
        this.state.services.map((service) => {
          this.serviceDataCleaner(service);
        });
      }
    }
  }
}
